/**
 * @module builder
 */
import type { OrderItem } from 'paintscout'
import findIndex from 'lodash/findIndex'

/**
 * Insert an OrderItem into an order array, relative to an anchor key.
 *
 * `insertBeforeKey` wins when both anchors are given.
 *
 * An anchor that is missing from the array appends. The anchor is a render-layer
 * key, so it is not guaranteed to exist in every order array - a substrate key is
 * absent from `order.area`, and an area key is absent from `order.substrate`.
 * Appending keeps an unresolved anchor at the bottom instead of the top (#23892).
 */
export function insertOrderItem(args: {
  order: OrderItem[]
  orderItem: OrderItem
  insertBeforeKey?: string
  insertAfterKey?: string
}): OrderItem[] {
  const { order, orderItem, insertBeforeKey, insertAfterKey } = args
  const result = [...order]

  if (insertBeforeKey) {
    const index = findIndex(result, { key: insertBeforeKey })
    if (index >= 0) {
      result.splice(index, 0, orderItem)
      return result
    }
  } else if (insertAfterKey) {
    const index = findIndex(result, { key: insertAfterKey })
    if (index >= 0) {
      result.splice(index + 1, 0, orderItem)
      return result
    }
  }

  result.push(orderItem)
  return result
}
